<template>
  <div
    v-if="item.isDynamicPanel && !dynamicPanelStatesRefreshing"
    class="qk-dynamic-panel-self"
    :style="{
      width: '100%',
      height: '100%',
      position: 'absolute',
      ...getDynamicPanelAnimationIn(item.uuid),
    }"
  >
    <div
      :style="getItemScrollStyle(item)"
      :class="{ 'scroll-hidden': item.isScrollHidden }"
    >
      <componentsTemplate
        v-for="(z, y) in elementsAll.filter(
          (o) =>
            o.dynamicPanelUUID == item.uuid &&
            o.dynamicPanelStateUUID ==
              item.states[dynamicPanelStatesCheck[o.dynamicPanelUUID].state]
                .uuid
        )"
        :key="y"
        :loaded="z._loaded"
        :element="z"
        :elementsAll="elementsAll"
        :elementGroups="elementGroups"
        :scalingRatio="scalingRatio"
        :style="
          getCommonStyle(
            {
              ...(z.isDynamicPanel
                ? { ...z.commonStyle, overflow: 'hidden' }
                : z.commonStyle),
            },
            scalingRatio
          )
        "
        @router="router"
      >
        <dynamic-panel-self
          v-if="z.isDynamicPanel"
          :item="z"
          :dynamicPanelStatesCheck="dynamicPanelStatesCheck"
          :elementsAll="elementsAll"
          :elementGroups="elementGroups"
          :scalingRatio="scalingRatio"
          @router="router"
        ></dynamic-panel-self>
      </componentsTemplate>
    </div>
  </div>
</template>

<script>
import componentsTemplate from "./components-template";
import { getCommonStyle } from "@/assets/js/utils";
export default {
  name: "dynamicPanelSelf",
  components: {
    componentsTemplate,
  },
  props: {
    item: Object,
    dynamicPanelStatesCheck: Object,
    elementsAll: Array,
    elementGroups: Array,
    scalingRatio: Number,
  },
  data() {
    return {
      getCommonStyle: getCommonStyle,
      dynamicPanelStatesRefresh: 0,
    };
  },
  computed: {
    dynamicPanelStatesRefreshing() {
      return this.dynamicPanelStatesRefresh;
    },
  },
  methods: {
    getItemScrollStyle(item) {
      let style = {};
      if (item.isScroll) {
        style = {
          position: "relative",
          overflow: "auto",
          width: "100%",
          height: "inherit",
        };
      }
      return style;
    },
    router(e) {
      this.$emit("router", e);
    },
    getDynamicPanelAnimationIn(uuid) {
      if (
        this.dynamicPanelStatesCheck[uuid] &&
        this.dynamicPanelStatesCheck[uuid].dynamicPanelAnimationIn
      ) {
        const css = {
          animationIterationCount: 1,
          animationDelay: 0,
          animationFillMode: "forwards",
          animationName:
            this.dynamicPanelStatesCheck[uuid].dynamicPanelAnimationIn,
        };
        if (
          this.dynamicPanelStatesCheck[uuid].dynamicPanelAnimationInMillisecond
        ) {
          css.animationDuration = `${
            parseInt(
              this.dynamicPanelStatesCheck[uuid]
                .dynamicPanelAnimationInMillisecond
            ) / 1000
          }s`;
        }
        return css;
      }
      return {};
    },
  },
};
</script>

<style lang="scss" scoped>
.element-on-edit-pane {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.scroll-hidden {
  &::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
  }
}
</style>
